import InquiryBadge from '@activities/customerService/InquiryActivity/components/InquiryLogs/InquiryBadge';
import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { InquiryResponse } from '@models/inquiry';

interface Props {
    inquiry: InquiryResponse;
}

function InquiryHeader({ inquiry }:Props) {
    const { status, title } = inquiry;
    return (
        <Container fullWidth as='section' spacing={14} >
            <InquiryBadge status={status}/>
            <Text size='2xl' fontWeight='bold'>
                {title}
            </Text>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 28px 20px 0;
`;

export default InquiryHeader;
